import { createChunksMatcher } from '../createChunksMatcher';
import { createChunk } from '../Chunks';
export function withData(maybeResolvableData, child) {
    return createChunksMatcher(maybeResolvableData, child, function (data, request) { return (data ? [createChunk('data', request, { data: data })] : []); });
}
//# sourceMappingURL=withData.js.map